export default {
  name: 'DefaultViewMixin',
  data() {
    return {
      defaultView: false
    }
  },
  created() {
    this.defaultView = true
  },
  
}
